import React from 'react'
import { connect } from 'react-redux'

import Col from 'muicss/lib/react/col'
import Row from 'muicss/lib/react/row'

import { loadCampaigns } from '../../../actions'
import Campaign from './Campaign'

const styles = {
  empty: {
    textAlign: 'center',
    minHeight: '300px',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
  },
}

const _chunk = (array) => {
  let i
  let j
  const temparray = []
  const chunk = 3
  for (i = 0, j = array.length; i < j; i += chunk) {
    temparray.push(array.slice(i, i + chunk))
  }
  return temparray
}

class Campaigns extends React.Component {

  componentDidMount = () =>
    this.props.loadCampaigns()

  _campaigns() {
    const { campaigns, hierarchy } = this.props
    const campaignsSorted = {} // campaignsSorted[row][col] is the campaign in that row and col

    // campaignsCompleted[row] is a bool.
    // true => all the campaigs have been passed
    const campaignsCompleted = {}

    let lastRow = 0 // the last row in the tree of campaigns
    const lastCol = {} // lastCol[row] is the number of cols in the row

    // initialize campaignsSorted, lastRow, lastCol
    campaigns.forEach((campaign) => {
      if (campaign.organizated) {
        if (lastRow < campaign.row) {
          lastRow = campaign.row
        }
        lastCol[campaign.row] = lastCol[campaign.row] || 0
        if (lastCol[campaign.row] < campaign.col) {
          lastCol[campaign.row] = campaign.col
        }
        campaignsSorted[campaign.row] = campaignsSorted[campaign.row] || {}
        campaignsSorted[campaign.row][campaign.col] = campaign
      }
    })
    const campaignsToRender = [] // array of campaigns to return (and render)

    // ?
    const lgOptions = {
      0: 0,
      1: 6,
      2: 8,
      3: 10,
    }
    const mdOptions = {
      0: 0,
      1: 4,
      2: 8,
      3: 12,
    }


    // set needToBeFullMode. If max cols in a array is 1 then FullMode = true
    let needToBeFullMode = true
    const numberOfCols = {}
    for (let r = 0; r <= lastRow; r += 1) {
      if (!campaignsSorted[r]) { continue }
      numberOfCols[r] = Object.keys(campaignsSorted[r]).length
      if (numberOfCols[r] > 1) {
        needToBeFullMode = false
      }
    }

    // generate campaignsCompleted
    for (let r = 0; r <= lastRow; r += 1) {
      if (!campaignsSorted[r]) { continue }
      campaignsCompleted[r] = true // guess that all are passed
      for (let c = 0; c <= lastCol[r]; c += 1) {
        const current_campaign = campaignsSorted[r][c]
        if (!current_campaign) { continue }
        campaignsCompleted[r] = (
          campaignsCompleted[r] &&
          (
            (current_campaign.completed_missions === current_campaign.total_missions) ||
            (current_campaign.hierarchy_type === 1 && campaignsCompleted[r - 1]) // if bonus then 'are completed'
          )
        )
      }
    }


    // generate campaignsToRender
    for (let r = 0; r <= lastRow; r += 1) {
      if (!campaignsSorted[r]) { continue }
      const setCampaigns = []
      const isAllParentsCampaignsCompleted = r === 0 || campaignsCompleted[r - 1]
      for (let c = 0; c <= lastCol[r]; c += 1) {
        const current_campaign = campaignsSorted[r][c]
        if (!current_campaign) { continue }
        setCampaigns.push(
          <Col sm={12 / numberOfCols[r]} key={current_campaign.id || c} >
            <Campaign
              {...current_campaign}
              campaignState={current_campaign.state}
              fullmode={needToBeFullMode}
              isAllParentsCampaignsCompleted={isAllParentsCampaignsCompleted}
              hierarchy={hierarchy}
            />
          </Col>,
        )
      }
      campaignsToRender.push(
        <Row key={r}>
          <Col
            md={needToBeFullMode ? 12 : mdOptions[numberOfCols[r]]}
            md-offset={needToBeFullMode ? 0 : ((12 - mdOptions[numberOfCols[r]]) / 2)}
            lg={needToBeFullMode ? 12 : lgOptions[numberOfCols[r]]}
            lg-offset={needToBeFullMode ? 0 : ((12 - lgOptions[numberOfCols[r]]) / 2)}
          >
            {setCampaigns}
          </Col>
        </Row>,
      )
    }

    return campaignsToRender
  }

  render() {
    const campaigns = this._campaigns()
    return (
      <div>
        {campaigns.length > 0
          ? campaigns
          : <Col xs="12" style={styles.empty}><h1>¡No tienes campañas disponibles!</h1></Col>}
      </div>
    )
  }

}

Campaigns.propTypes = {
  loadCampaigns: React.PropTypes.func.isRequired,
  campaigns: React.PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
}

const mapStateToProps = state => ({
  ...state.campaigns,
})

const mapDispatchToProps = dispatch => ({
  loadCampaigns: () => dispatch(loadCampaigns()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Campaigns)



// WEBPACK FOOTER //
// ./src/components/Main/Campaigns/index.jsx